import { render, staticRenderFns } from "./TNewsSeo.vue?vue&type=template&id=6c614cd4&"
import script from "./TNewsSeo.vue?vue&type=script&lang=js&"
export * from "./TNewsSeo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports